"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSpecializationsNode = exports.SpecializationsFields = void 0;
exports.isValidSpecializationsField = isValidSpecializationsField;
exports.makeSpecializations = makeSpecializations;
const utils_1 = require("../utils");
const ast_classes_1 = require("../ast-classes");
/**
 * Define all allowed `specializations` attributes:
 * The only allowed field is `specializations`
 */
exports.SpecializationsFields = ['specializations'];
/**
 * Check if the attributes `specializations` of the `Specializations` node is valid
 *
 * @param field - A string containing the name of the attributes
 * @param value - A BasicValue-typed value containing the attributes value
 * @returns Boolean
 */
function isValidSpecializationsField(field, value) {
    switch (field) {
        case 'specializations': return (0, utils_1.isOrUndefined)(ast_classes_1.isINCLUDED_DOMAINS, value);
        default: return false;
    }
}
/**
 * Check if the `specializations` node is valid
 *
 * @remarks
 * Assert that the node is an object and has a valid attribute
 *
 * @param value - The `specializations` node to test
 * @returns Boolean
 */
const isSpecializationsNode = (value) => typeof value === 'object' && !!value && (0, utils_1.areFieldsValid)(exports.SpecializationsFields, value, isValidSpecializationsField);
exports.isSpecializationsNode = isSpecializationsNode;
/**
 * Create a `Specializations` node with a `specializations` attribute
 *
 * @param constructor - The constructor
 * @returns The `variable-content` node with a `specializations` attribute and its value
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function makeSpecializations(constructor) {
    return class extends constructor {
        get 'specializations'() {
            return this.readProp('specializations');
        }
        set 'specializations'(value) {
            this.writeProp('specializations', value);
        }
    };
}
//# sourceMappingURL=specializations-type.js.map